export const CONTACT = {
  business: 'ProScape Outdoor Services',
  phoneDisplay: '(607) 346-4605',
  phoneTel: '+16073464605',
  serviceArea: 'Corning, NY & surrounding areas',
  facebookUrl: 'https://www.facebook.com/profile.php?id=61565246764162',
};
